import { Box, Drawer, useTheme, alpha, styled, keyframes } from "@mui/material";
import { getColors } from "../Themes/default_color";
import { getContrastText } from "../utils/commonUtilities";
const ChatAi = styled(Box)(() => {
    const theme = useTheme();
    return {
        '& .cstChatHoverZone': {
            position: 'fixed',
            right: theme.spacing(4),
            bottom: theme.spacing(6.5),
            width: '100px',
            height: '88px',
            zIndex: 1299,
        },
        '& .cstChatBtn': {
            position: 'fixed',
            right: theme.spacing(4),
            bottom: theme.spacing(6.5),
            background: 'transparent',
            boxShadow: 'none',
            boxSizing: 'border-box',
            height: '88px',
            width: '88px',
            borderRadius: '999px',
            border: '1px solid transparent',
            zIndex: 1299,
            '&.cstChatBtn--in-hover-zone': {
                position: 'absolute',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
            },
            transition: [
                'right 0.55s cubic-bezier(0.34, 1.56, 0.64, 1)',
                'bottom 0.55s cubic-bezier(0.34, 1.56, 0.64, 1)',
                'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                'height 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                'border-radius 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                'background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                'border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            ].join(', '),
            '&.cstChatBtn--collapsed:hover': {
                background: 'transparent',
                opacity: 0.9,
            },
            '& .cstChatIdleContent': {
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: 1,
                transition: 'opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                zIndex: 1299,
            },
            '& .cstChatHoverContent': {
                position: 'absolute',
                top: 0,
                right: 0,
                width: '100px',
                height: '48px',
                opacity: 0,
                pointerEvents: 'none',
                transition: 'opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                zIndex: 1299,
            },
        },
        '& .cstChatHoverZone:hover .cstChatBtn': {
            width: '100px',
            height: '48px',
            background: '#20285C',
            border: '1px solid #BED4E8',
            borderRadius: '30px',
            right: '25px',
            bottom: theme.spacing(8),
        },
        '& .cstChatHoverZone:hover .cstChatIdleContent': {
            opacity: 0,
        },
        '& .cstChatHoverZone:hover .cstChatHoverContent': {
            opacity: 1,
            pointerEvents: 'auto',
        },
    };
});
const ChatSlider = styled(Drawer)(() => {
    const colors = getColors();
    const theme = useTheme();
    return {
        '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(16, 19, 31, 0.38)',
        },
        '& .MuiDrawer-paper': {
            width: '350px',
            top: '110px',
            right: '20px',
            height: 'calc(100dvh - 130px)',
            borderRadius: '10px',
            overflow: 'hidden',
            boxShadow: '0px 12px 32px rgba(19, 28, 58, 0.26)',
            [theme.breakpoints.down('sm')]: {
                top: '74px',
                right: '10px',
                width: '88vw',
                height: 'calc(100dvh - 94px)',
            },
            '& .cstSlider': {
                backgroundColor: '#FFFFFF',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            },
            '& .sliderHeader': {
                backgroundColor: colors.Primary,
                minHeight: '34px',
                padding: '8px 10px',
                flexShrink: 0,
                borderBottom: 'none',
                '& .MuiIconButton-root svg path': {
                    fill: `${getContrastText(colors.Primary)} !important`,
                },
                '& .MuiTypography-root': {
                    color: `${getContrastText(colors.Primary)} !important`,
                },
                '& .chatHeaderIcon': {
                    display: 'flex',
                    alignItems: 'center',
                },
                '& .chatHeaderIcon svg': {
                    display: 'block',
                },
                '& .chatHeaderTitle': {
                    fontSize: 16,
                    lineHeight: '20px',
                    fontWeight: 500,
                },
                '& .MuiIconButton-root': {
                    padding: 4,
                }
            },
            '& .sliderBody': {
                flex: 1,
                minHeight: 0,
                overflowY: 'auto',
                overflowX: 'hidden',
                backgroundColor: '#FFFFFF',
                padding: '12px 8px 6px',
                marginBottom: '15px',
                '& .sliderContent': {
                    minHeight: '100%',
                    rowGap: 6,
                    '& .welcomeMessage': {
                        padding: '2px 6px 0',
                    },
                    '& .welcomeTitle': {
                        fontSize: 18,
                        lineHeight: '24px',
                        fontWeight: 600,
                        color: '#0057D8',
                        marginBottom: 2,
                    },
                    '& .welcomeDesc': {
                        fontSize: 14,
                        lineHeight: '20px',
                        fontWeight: 400,
                        color: '#1B1F2D',
                        letterSpacing: 0,
                    },
                    '& .welcomeDesc.hasLine': {
                        paddingBottom: 10,
                        marginBottom: 8,
                        borderBottom: '1px solid #E0E4ED',
                    },
                    '& .menuOptionWrap': {
                        marginTop: 8,
                    },
                    '& .menuTimestamp': {
                        textAlign: 'right',
                        fontSize: 11,
                        color: '#9EA3AF',
                        paddingRight: 4,
                        marginTop: 4,
                    },
                    '& .botAvatar': {
                        width: 32,
                        height: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        '& svg': {
                            width: 32,
                            height: 32,
                        },
                    },
                    '& .reciever, & .sender': {
                        width: '100%',
                        '& svg': {
                            color: colors.Primary,
                        },
                        '& .recieverText, & .senderText': {
                            flex: 1,
                            minWidth: 0,
                            overflow: 'visible',
                            '& .msgBubble': {
                                display: 'flex',
                                flexDirection: 'column',
                                background: '#F5F7FA',
                                borderRadius: theme.spacing(1.5),
                                borderTopLeftRadius: 0,
                                padding: theme.spacing(1.5),
                                '& p': {
                                    fontSize: 14,
                                    lineHeight: '20px',
                                    wordBreak: 'break-word',
                                    overflowWrap: 'break-word',
                                    display: 'block',
                                    boxSizing: 'border-box',
                                    '& + p': {
                                        marginTop: theme.spacing(0.5),
                                    },
                                    '& ol, & ul': {
                                        paddingLeft: '20px',
                                        margin: '4px 0',
                                    },
                                    '& li': {
                                        wordBreak: 'break-word',
                                    },
                                    '& table': {
                                        maxWidth: '100%',
                                        overflowX: 'auto',
                                        display: 'block',
                                    },
                                },
                                '& .msgTime': {
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    fontSize: 10,
                                    color: '#A2A2A9',
                                    textTransform: 'uppercase',
                                    marginTop: '4px',
                                },
                            },
                            '& small': {
                                fontSize: theme.spacing(1.5),
                                fontWeight: 400,
                                color: '#3F3F3F',
                            },
                        },
                    },
                    '& .reciever': {
                        alignItems: 'flex-end',
                    },
                    '& .sender': {
                        width: '100%',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-end',
                        '& .senderText': {
                            flex: 'unset',
                            maxWidth: '85%',
                            '& .msgBubble': {
                                background: '#EAF1F8',
                                borderTopLeftRadius: theme.spacing(1.5),
                                borderBottomRightRadius: 0,
                            },
                        },
                    },
                    '& .actions .MuiButtonBase-root': {
                        border: '1px solid #D8D8D8',
                        color: colors.black,
                    },
                    '& .menu-options': {
                        padding: '12px 14px',
                        borderRadius: 8,
                        border: '1px solid #D4D4D8 !important',
                        background: '#FFFFFF !important',
                        width: '100% !important',
                        boxSizing: 'border-box',
                        boxShadow: '0px -4px 4px -2px #4D4D4D0F',
                        '&:hover': {
                            background: '#F7F9FF !important',
                            borderColor: '#A8B4D0 !important',
                        },
                    },
                    '& .menu-options-tour': {
                        border: 'none !important',
                        background: 'linear-gradient(90deg, #3F51F7 0%, #6D32EA 100%) !important',
                        boxShadow: '0px 4px 12px 0px #3F51F74D',
                        '&:hover': {
                            background: 'linear-gradient(90deg, #3F51F7 0%, #6D32EA 100%) !important',
                            borderColor: 'transparent !important',
                        },
                        '& .menuTitle, & .menuNote': {
                            color: '#FFFFFF',
                        },
                        '& .menuNote': {
                            opacity: 0.85,
                        },
                    },
                    '& .menu-options-tour-animate': {
                        animation: `${sparkleOpacity} 3.6s linear 1, ${sparkleTranslate} 3.6s linear 1`,
                    },
                    '& .menuTitle': {
                        fontSize: 15,
                        lineHeight: '20px',
                        fontWeight: 600,
                        color: '#1D2232',
                    },
                    '& .menuNote': {
                        fontSize: 12,
                        lineHeight: '17px',
                        color: '#B6B6BC',
                    },
                    '& .chatTimestamp': {
                        marginTop: 'auto',
                        textAlign: 'right',
                        fontSize: 10,
                        color: '#9EA3AF',
                        paddingRight: 4,
                    }
                },
            },
            '& .sliderFooter ': {
                position: 'relative',
                width: '100%',
                flexShrink: 0,
                backgroundColor: '#FFFFFF',
                padding: '6px 0 8px',
                borderTop: '1px solid #EEF1F6',
                '& .MuiFormControl-root .MuiInputBase-root': {
                    background: '#F3F4F7',
                    padding: '2px 10px',
                    margin: '0px 8px',
                    borderRadius: 6,
                    '& .MuiInputBase-input': {
                        padding: '8px 0',
                        paddingLeft: 4,
                        fontSize: 12,
                        overflowY: 'auto !important',
                        maxHeight: '100px',
                    },
                    '& .MuiInputAdornment-root .chatActionBtn svg': {
                        color: getContrastText(colors.Primary),
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none',
                    },
                    '& .chatActionBtn': {
                        width: 30,
                        height: 30,
                        borderRadius: 6,
                        background: colors.Primary,
                        padding: 0,
                        marginLeft: 6,
                        '&:hover': {
                            background: colors.Primary,
                        },
                        '& svg': {
                            fontSize: 16,
                        },
                    },
                    '& .chatActionBtn.sendBtn': {
                        background: colors.Primary,
                        '&:hover': {
                            background: colors.Primary,
                        },
                    },
                    '& .chatActionBtn.Mui-disabled': {
                        opacity: 0.55,
                        background: colors.Primary,
                    }
                },
                '& .animated-icon-button': {
                    position: 'relative',
                    overflow: 'visible',
                    marginRight: 4,
                    '& .ripple-wrapper': {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        pointerEvents: 'none',
                        '& .ripple-circle': {
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            background: alpha(colors.Primary, 0.8),
                            borderRadius: '50%',
                            animation: `${rippleAnimation} 0.5s infinite ease-out`,
                        },
                    }
                }
            }
        },
    };
});
export { ChatAi, ChatSlider };
const sparkleOpacity = keyframes `
  0% {
    animation-timing-function: ease-out;
    opacity: 0;
  }
  16.667% {
    opacity: 1;
  }
  77.778% {
    animation-timing-function: ease-in;
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;
const sparkleTranslate = keyframes `
  0% {
    animation-timing-function: ease-out;
    translate: 0px 10px;
  }
  16.667% {
    animation-timing-function: ease-in-out;
    translate: 0px 0px;
  }
  38.889% {
    animation-timing-function: ease-in-out;
    translate: 0px -7px;
  }
  61.111% {
    animation-timing-function: ease-in;
    translate: 0px 0px;
  }
  100% {
    translate: 0px -12px;
  }
`;
const rippleAnimation = keyframes `
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
`;
